module.exports = __webpack_public_path__ + "img/media-bg.e9b5d777.png";